<div [formGroup]="parentForm">
  <div formGroupName="shelfInfo">
    <div class="row">
      <div class="col-md-6 mb-3">
        <label for="shelfName"
          >{{ showShelfName | pureFn: isShowShelfType : env }}<span class="text-danger">*</span></label
        >
        <input
          id="shelfName"
          data-id="shelfName"
          name="shelfName"
          type="text"
          class="form-control"
          maxlength="100"
          formControlName="shelfName"
          [placeholder]="showShelfName | pureFn: isShowShelfType : env"
          [ngClass]="{
            'is-invalid': (saved || submitted) && form.controls.shelfName.errors,
            'bg-h-change': hasChanges('shelfName')
          }"
        />
        <div *ngIf="(saved || submitted) && form.controls.shelfName.errors" class="invalid-feedback">
          <div *ngIf="form.controls.shelfName.errors.required">
            {{ 'ERRORS.REQUIRED' | translate }}
          </div>
        </div>
      </div>
      <div class="col-md-6 mb-3" *ngIf="isShowShelfType">
        <label for="shelfType">Shelf Type<span class="text-danger">*</span></label>
        <ng-select
          formControlName="shelfType"
          placeholder="Please select..."
          id="shelfType"
          data-id="shelfType"
          [items]="shelfTypeList$ | async"
          [typeahead]="shelfTypeSearchInput$"
          [loading]="shelfTypeSearchLoading"
          bindLabel="displayName"
          bindValue="code"
          notFoundText="No Data"
          [ngClass]="{
            'is-invalid': submitted && form.controls.shelfType.errors,
            'bg-h-change': hasChanges('shelfType')
          }"
        >
          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
            <div [ngOptionHighlight]="search" class="ml-1">{{ item.displayName }}</div>
          </ng-template>
          <ng-template ng-footer-tmp>
            <div class="add-shelf-type-label ml-1">
              <a class="btn-text-link" (click)="goToShelfType()">+ Add Shelf Type</a>
            </div>
          </ng-template>
        </ng-select>
        <div *ngIf="submitted && form.controls.shelfType.errors" class="invalid-feedback">
          <div *ngIf="form.controls.shelfType.errors.required">
            {{ 'ERRORS.REQUIRED' | translate }}
          </div>
        </div>
      </div>
      <div class="col-md-6 mb-3">
        <label for="shelfImage">Shelf Image<span class="text-danger">*</span></label>
        <app-files-upload
          #shelfImage
          id="shelfImage"
          data-id="shelfImage"
          formControlName="shelfImage"
          class="form-control"
          [hasError]="submitted && form.controls.shelfImage.errors"
          [hasChange]="hasChanges('shelfImage')"
          [allowedTypes]="propImageAllowedTypes"
          [withMeta]="true"
          [size]="propImageSize"
          [controlName]="'shelfImage'"
          [allowedExt]="propImageAllowedExt"
          [descriptionTxt]="propImageDescriptionTxt"
          [fileSizeErrorTxt]="propImageFileSizeErrorTxt"
          [fileTypeErrorTxt]="propImageFileTypeErrorTxt"
          [fileModule]="fileModule.SHELF_TYPE"
        ></app-files-upload>
      </div>
    </div>
  </div>
</div>
